import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

// APP-PENDING-PAGE (claims contract, named requirement): an entitled user
// whose account was JIT-created with zero roles must see this exact page —
// never a generic error or broken UI.
const ADMIN_CONTACT = 'the FOP IPT administrator (peter@cxfop.com)';

export default function Pending() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-md p-6 space-y-4">
        <h1 className="text-xl font-semibold text-cathay-700">Access pending</h1>
        <p className="text-sm text-slate-700">
          Your account is created — access pending. Contact {ADMIN_CONTACT} to be granted a role
          in the IPT Management App.
        </p>
        {user?.email && (
          <p className="text-xs text-slate-500">
            Signed in as <span className="font-mono">{user.email}</span>
          </p>
        )}
        <button
          onClick={async () => {
            await logout(); // never throws — best-effort by design
            navigate('/login?signedout=1', { replace: true });
          }}
          className="w-full bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 py-2 rounded text-sm"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
